import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/preparePackageTourBook', request)
}

export {post}
